// extracted by mini-css-extract-plugin
export default {"section":"Stats_section__2VQev","row":"Stats_row__TPxM7","box":"Stats_box__o1rVi","num":"Stats_num__gpmxQ","label":"Stats_label__S7OAH"};